/* GA4 dataLayer — Brandon Blackwood. Pushes GA4 events to window.dataLayer for GTM.
   Server context: window.BB_GA4 (layout/theme.liquid). Per-item data: data-ga4-item on
   .product-card (ga4-item.liquid) and #bb-ga4-view-item on the PDP (product-section.liquid). */
(function () {
  'use strict';

  var CONFIG = window.BB_GA4 || {};
  var CURRENCY = CONFIG.currency || 'USD';
  // Cap view_item_list payloads; avoid re-firing on PLP infinite scroll / page 2+.
  var MAX_VIEW_ITEM_LIST = 20;
  window.dataLayer = window.dataLayer || [];

  function push(o) {
    window.dataLayer.push(o);
  }
  // Clear ecommerce before each push so items don't leak between events.
  function pushEcommerce(event, ecommerce) {
    push({ ecommerce: null });
    push({ event: event, ecommerce: ecommerce });
  }
  function txt(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function round2(n) {
    return Math.round((Number(n) || 0) * 100) / 100;
  }
  function handleize(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function closestA(e) {
    return e.target.closest && e.target.closest('a[href]');
  }
  function nodeIndex(nodes, el) {
    var i = Array.prototype.indexOf.call(nodes, el);
    return i < 0 ? 1 : i + 1;
  }

  // Single delegated click listener; feature handlers register via onClick.
  // try/catch per handler preserves the error isolation that separate listeners gave us
  // (one handler throwing must not stop the others from running).
  var clickHandlers = [];
  function onClick(fn) {
    clickHandlers.push(fn);
  }
  document.addEventListener(
    'click',
    function (e) {
      for (var i = 0; i < clickHandlers.length; i++) {
        try {
          clickHandlers[i](e);
        } catch (err) {}
      }
    },
    true,
  );

  // Filter/sort state only — strip page params so scroll/pagination does not look like a new list.
  function listFilterKey() {
    try {
      var u = new URL(window.location.href);
      ['page', 'pg', 'p', 'page_num'].forEach(function (k) {
        u.searchParams.delete(k);
      });
      return u.pathname + u.search;
    } catch (e) {
      return location.pathname + location.search;
    }
  }

  // Dedupe view_item_list (by list + filter state + item ids), then push.
  // Caps at MAX_VIEW_ITEM_LIST. Allows one grow-up to the cap on first paint, then
  // skips scroll/pagination until filters/sort (URL without page params) change.
  function fireList(holder, ctx, items) {
    if (!items.length) return;
    items = items.length > MAX_VIEW_ITEM_LIST ? items.slice(0, MAX_VIEW_ITEM_LIST) : items;
    var filterKey = listFilterKey();
    var prevCount = holder.__bbListCount || 0;
    if (holder.__bbLastFilterKey === filterKey && prevCount >= items.length) return;
    var sig =
      (ctx.id || '') +
      '|' +
      filterKey +
      '|' +
      items
        .map(function (it) {
          return it.item_id || it.item_name || '';
        })
        .join(',');
    if (holder.__bbLastSig === sig) return;
    holder.__bbLastSig = sig;
    holder.__bbLastFilterKey = filterKey;
    holder.__bbListCount = items.length;
    pushEcommerce('view_item_list', {
      item_list_id: ctx.id,
      item_list_name: ctx.name,
      currency: CURRENCY,
      items: items,
    });
  }
  function selectItem(ctx, item) {
    pushEcommerce('select_item', {
      item_list_id: ctx.id,
      item_list_name: ctx.name,
      currency: CURRENCY,
      items: [item],
    });
  }

  function listContext(el) {
    var h = el.closest && el.closest('[data-ga-list-name]');
    if (h) {
      var name = h.getAttribute('data-ga-list-name') || '';
      return { id: h.getAttribute('data-ga-list-id') || handleize(name), name: name };
    }
    return CONFIG.list && (CONFIG.list.id || CONFIG.list.name) ? CONFIG.list : { id: '', name: '' };
  }

  // item_id = Shopify product_id everywhere (consistent funnel; Boost SD PLP has no SKU).
  function lineToItem(l, qty) {
    var item = {
      item_id: String(l.product_id || l.variant_id || l.id || ''),
      item_name: l.product_title || l.title || '',
      item_brand: l.vendor || 'Brandon Blackwood',
      price: round2((l.final_price != null ? l.final_price : l.price || 0) / 100),
      quantity: qty != null ? qty : l.quantity,
    };
    if (l.variant_title) item.item_variant = l.variant_title;
    if (l.product_type) item.item_category = l.product_type;
    return item;
  }

  function isRouteLine(l) {
    return /(shipping|package)\s+protection/i.test(l.product_title || l.title || '');
  }

  function discountCode(cart) {
    var a = cart && (cart.discount_applications || cart.cart_level_discount_applications);
    return a && a.length ? a[0].code || a[0].title || '' : '';
  }

  // page_viewed
  function firePageView() {
    push({
      event: 'page_viewed',
      page_type: CONFIG.page_type || '',
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }

  /* view_item_list / select_item — theme .product-card grids (sliders, PDP recs, and
     Boost SSR first load). Boost SD PLP is handled separately below. */
  function itemFromCard(card, index) {
    var data;
    try {
      data = JSON.parse(card.getAttribute('data-ga4-item'));
    } catch (e) {}
    if (!data) {
      // Fallback: scrape (Boost client-rendered cards lack data-ga4-item).
      data = {};
      var t = card.querySelector('.product-card__title');
      var pr = card.querySelector('.product-card__price');
      var link = card.querySelector('a[href*="/products/"]');
      if (t) data.item_name = txt(t);
      if (pr) {
        var n = parseFloat((pr.textContent || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(n)) data.price = n;
      }
      if (link) {
        var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) data.item_id = m[1];
      }
    }
    var item = {};
    ['item_id', 'item_name', 'item_brand', 'item_category', 'item_variant', 'price'].forEach(
      function (k) {
        if (data[k] != null && data[k] !== '') item[k] = data[k];
      },
    );
    if (index != null) item.index = index;
    return item;
  }

  function fireViewItemList(root) {
    var cards = root.querySelectorAll('.product-card');
    if (!cards.length) return;
    var items = [];
    var limit = Math.min(cards.length, MAX_VIEW_ITEM_LIST);
    for (var i = 0; i < limit; i++) {
      items.push(itemFromCard(cards[i], i + 1));
    }
    fireList(root, listContext(root), items);
  }

  function observeBoostMutations(root) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        fireViewItemList(root);
      }, 400);
    }).observe(root, { childList: true });
  }

  function observeList(root) {
    if (!('IntersectionObserver' in window)) return fireViewItemList(root);
    // threshold 0: a full collection grid is many viewports tall, so its max
    // intersection ratio never reaches a higher threshold — it must fire on any pixel.
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            io.disconnect();
            fireViewItemList(root);
          }
        });
      },
      { threshold: 0 },
    );
    io.observe(root);
  }

  /* Boost PFS integration: boost-pfs-filter.js afterRender hook calls onBoostRender with
     the full product array. We build items, stamp cards (so select_item matches), and fire. */
  var boostHookActive = false;

  function boostFirstVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i] && vs[i].available) return vs[i];
    return vs[0] || {};
  }

  // NOTE: Boost prices are already in major units (dollars) — do NOT divide by 100.
  function boostItemToGa4(p, i) {
    var v = boostFirstVariant(p);
    var item = {
      item_id: String(p.id || ''),
      item_name: p.title || '',
      item_brand: p.vendor || 'Brandon Blackwood',
      item_category: p.type || '',
      price: round2(p.price_min != null ? p.price_min : v.price || 0),
    };
    if (v.title && v.title !== 'Default Title') item.item_variant = v.title;
    if (i != null) item.index = i + 1;
    if (!item.item_name) delete item.item_name;
    if (!item.item_category) delete item.item_category;
    return item;
  }

  function onBoostRender(products) {
    boostHookActive = true;
    if (!products || !products.length) return;
    var container = document.querySelector('.boost-pfs-filter-products');
    var holder = container || document.body;
    var slice = products.slice(0, MAX_VIEW_ITEM_LIST);
    var items = slice.map(function (p, i) {
      return boostItemToGa4(p, i);
    });
    if (container) {
      var cards = container.querySelectorAll('.product-card');
      for (var j = 0; j < cards.length && j < items.length; j++) {
        if (!cards[j].getAttribute('data-ga4-item')) {
          try {
            cards[j].setAttribute('data-ga4-item', JSON.stringify(items[j]));
          } catch (e) {}
        }
      }
    }
    fireList(holder, listContext(holder), items);
  }

  function initListing() {
    var seen = [];
    function addRoot(n, isBoost) {
      if (!n || seen.indexOf(n) >= 0) return;
      seen.push(n);
      observeList(n);
      // Fallback if the Boost afterRender hook is absent (app overwrote the file).
      if (isBoost)
        setTimeout(function () {
          if (!boostHookActive) observeBoostMutations(n);
        }, 3000);
    }
    document.querySelectorAll('[data-ga-list-name]').forEach(function (n) {
      addRoot(n, false);
    });
    document.querySelectorAll('.boost-pfs-filter-products').forEach(function (n) {
      if (!n.closest('[data-ga-list-name]')) addRoot(n, true);
    });

    onClick(function (e) {
      var link = e.target.closest && e.target.closest('.product-card a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('.product-card');
      if (!card) return;
      var root =
        card.closest('[data-ga-list-name]') ||
        card.closest('.boost-pfs-filter-products') ||
        card.parentElement;
      var item = itemFromCard(
        card,
        root ? nodeIndex(root.querySelectorAll('.product-card'), card) : 1,
      );
      selectItem(listContext(card), item);
    });
  }

  /* Boost SD (AI Search & Discovery) — the live collection/search PLP, client-rendered as
     <ul.boost-sd__product-list><li.boost-sd__product-item> with a data-product JSON. */
  function boostSDContext() {
    return CONFIG.list && (CONFIG.list.id || CONFIG.list.name) ? CONFIG.list : { id: '', name: '' };
  }

  function boostSDItem(li, index) {
    var data;
    try {
      data = JSON.parse(li.getAttribute('data-product'));
    } catch (e) {}

    var titleEl = li.querySelector('.boost-sd__product-title');
    var link = li.querySelector('a.boost-sd__product-link, a[href*="/products/"]');

    var pid = li.getAttribute('data-product-id') || (data && (data.productId || data.handle)) || '';
    if (!pid && link) {
      var hm = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (hm) pid = hm[1];
    }
    if (!pid) return null;

    var item = { item_id: String(pid) };
    var name = titleEl ? txt(titleEl) : link ? (link.getAttribute('aria-label') || '').trim() : '';
    if (name) item.item_name = name;
    item.item_brand = 'Brandon Blackwood';

    // item_category = Boost's own category field (whatever it provides, e.g. "Sizes 35-44").
    if (data && data.category) item.item_category = String(data.category).trim();
    // item_variant = colour option value (matches the SSR/spec convention).
    var opts = (data && data.options_with_values) || [];
    var opt = null;
    for (var o = 0; o < opts.length; o++) {
      var nm = (opts[o].original_name || opts[o].name || opts[o].label || '').toLowerCase();
      if (nm === 'color' || nm === 'colour') {
        opt = opts[o];
        break;
      }
    }
    opt = opt || opts[0];
    if (opt && opt.values && opt.values[0]) item.item_variant = (opt.values[0].title || '').trim();

    // Boost SD priceMin is already in major units (matches the visible price and the
    // scrape fallback below) — do NOT divide by 100.
    if (data && data.priceMin) {
      var pr = Number(data.priceMin);
      if (!isNaN(pr)) item.price = round2(pr);
    } else {
      var priceEl = li.querySelector('.boost-sd__product-price');
      if (priceEl) {
        var ps = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(ps)) item.price = round2(ps);
      }
    }
    if (index != null) item.index = index;
    return item;
  }

  /* Dedupe keyed by list id + filter state (not the ul): Boost remounts the ul on
     filter/sort/paginate. Cap at MAX_VIEW_ITEM_LIST; skip re-fire on scroll/page 2+. */
  var boostSDFiredFilterKey = {};
  var boostSDLastCount = {};
  function fireBoostSDList(list) {
    var ctx = boostSDContext();
    var filterKey = listFilterKey();
    var prevCount = boostSDLastCount[ctx.id] || 0;
    if (boostSDFiredFilterKey[ctx.id] === filterKey && prevCount >= MAX_VIEW_ITEM_LIST) return;

    var items = [];
    var nodes = list.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < nodes.length && items.length < MAX_VIEW_ITEM_LIST; i++) {
      var it = boostSDItem(nodes[i], items.length + 1);
      if (it) items.push(it);
    }
    if (!items.length) return;
    if (boostSDFiredFilterKey[ctx.id] === filterKey && prevCount >= items.length) return;

    boostSDFiredFilterKey[ctx.id] = filterKey;
    boostSDLastCount[ctx.id] = items.length;
    pushEcommerce('view_item_list', {
      item_list_id: ctx.id,
      item_list_name: ctx.name,
      currency: CURRENCY,
      items: items,
    });
  }

  function initBoostSD() {
    if (CONFIG.page_type !== 'collection' && CONFIG.page_type !== 'search') return;
    // Observe document.body (not just .boost-sd-container, which Boost injects late).
    var scope = document.body;
    function scan() {
      // First: a throw below must not suppress custom_search. fireSearch() only fires once.
      var count = boostResultCount();
      if (count != null) fireSearch(count);
      var list = document.querySelector('ul.boost-sd__product-list');
      if (list) fireBoostSDList(list);
    }
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 350);
    }).observe(scope, { childList: true, subtree: true });
    // Fixed-delay fallback scans guarantee we check after Boost's async render settles, even if a
    // mutation the observer misses (attribute-only fill / remount) populated the list. scan() is
    // idempotent via boostSDFiredFilterKey, so repeat calls are safe.
    [400, 900, 1800, 3000, 5000].forEach(function (d) {
      setTimeout(scan, d);
    });
    scan();

    onClick(function (e) {
      var link =
        e.target.closest && e.target.closest('.boost-sd__product-item a[href*="/products/"]');
      if (!link) return;
      var li = link.closest('.boost-sd__product-item');
      if (!li) return;
      var list = li.closest('ul.boost-sd__product-list');
      var item = boostSDItem(
        li,
        list ? nodeIndex(list.querySelectorAll('.boost-sd__product-item'), li) : 1,
      );
      if (item) selectItem(boostSDContext(), item);
    });
  }

  // view_item
  function fireViewItem() {
    var el = CONFIG.page_type === 'product' && document.getElementById('bb-ga4-view-item');
    if (!el) return;
    try {
      pushEcommerce('view_item', JSON.parse(el.textContent));
    } catch (e) {}
  }

  /* add_to_cart / remove_from_cart / view_cart / begin_checkout — Liquid Ajax Cart is
     the single source for cart mutations. */
  function itemsFromCart(cart) {
    return (cart.items || []).map(function (l) {
      return lineToItem(l);
    });
  }
  function indexByKey(cart) {
    var m = {};
    (cart.items || []).forEach(function (l) {
      m[l.key] = l;
    });
    return m;
  }
  function fireViewCart(cart) {
    if (!cart || !cart.item_count) return;
    pushEcommerce('view_cart', {
      currency: CURRENCY,
      value: round2((cart.total_price || 0) / 100),
      items: itemsFromCart(cart),
    });
  }

  function initCart() {
    var prev = null;

    // Push `event` for each cart line whose quantity went up from `before` to `after`.
    function reportQuantityIncreases(before, after, event) {
      Object.keys(after).forEach(function (key) {
        var added = after[key].quantity - (before[key] ? before[key].quantity : 0);
        if (added > 0) {
          var item = lineToItem(after[key], added);
          pushEcommerce(event, {
            currency: CURRENCY,
            value: round2(item.price * added),
            items: [item],
          });
        }
      });
    }
    function handleState(cart) {
      if (!cart) return;
      if (prev) {
        var before = indexByKey(prev);
        var after = indexByKey(cart);
        reportQuantityIncreases(before, after, 'add_to_cart'); // lines that grew = added
        reportQuantityIncreases(after, before, 'remove_from_cart'); // lines that shrank = removed
      }
      prev = cart; // first call just seeds the baseline
      window.__bbCart = cart;
    }
    function subscribe() {
      var laj = window.liquidAjaxCart;
      if (!laj || typeof laj.subscribeToCartStateUpdate !== 'function') return false;
      laj.subscribeToCartStateUpdate(function (state) {
        handleState(state && state.cart ? state.cart : state);
      });
      return true;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (!prev) prev = c;
        window.__bbCart = c;
        if (CONFIG.page_type === 'cart') fireViewCart(c);
      })
      .catch(function () {});

    if (!subscribe()) {
      var tries = 0;
      var iv = setInterval(function () {
        if (subscribe() || ++tries > 50) clearInterval(iv);
      }, 100);
    }

    onClick(function (e) {
      var btn =
        e.target.closest &&
        e.target.closest(
          '[name="checkout"], .cart__view, a[href*="/checkout"], .route-continue-without-coverage-link',
        );
      if (!btn) return;
      var cart = window.__bbCart;
      if (!cart || !cart.item_count) return;
      // Fire once per checkout intent (guards duplicate/re-dispatched clicks); window-scoped.
      if (Date.now() - (window.__bbLastBeginCheckout || 0) < 2000) return;
      window.__bbLastBeginCheckout = Date.now();

      var line = document.querySelector('[data-route-static-line]');
      var cents = btn.closest('.route-continue-without-coverage-link')
        ? 0
        : (line && parseInt(line.getAttribute('data-route-cents'), 10)) || 0;

      var value = cart.total_price || 0;
      var items = [];
      (cart.items || []).forEach(function (l) {
        if (isRouteLine(l)) value -= l.final_line_price || 0;
        else items.push(lineToItem(l));
      });
      if (cents) {
        value += cents;
        items.push({
          item_id: 'shipping_protection_route',
          item_name: 'Shipping Protection by Route',
          item_brand: 'Route',
          item_category: 'Shipping Protection',
          price: round2(cents / 100),
          quantity: 1,
        });
      }

      var eco = {
        currency: CURRENCY,
        value: round2(value / 100),
        shipping_protection: cents ? 'yes' : 'no',
        items: items,
      };
      var code = discountCode(cart);
      if (code) eco.coupon = code;
      pushEcommerce('begin_checkout', eco);
    });
  }

  /* Boost SD renders the search results. Boost publishes its real total on #results-number; null = it hasn't rendered yet. */
  function boostResultCount() {
    var el = document.querySelector('[data-total-product]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-total-product'), 10);
    return isNaN(n) ? null : n;
  }

  /* custom_search - once per unique search this session */
  var searchFired = false;
  function fireSearch(count) {
    if (searchFired) return;
    if (CONFIG.page_type !== 'search' || !CONFIG.search || !CONFIG.search.term) return;
    searchFired = true;
    var key = 'bb_ga4_search:' + location.pathname + location.search;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}
    push({
      event: 'custom_search',
      search_term: CONFIG.search.term,
      search_results_count: count,
    });
  }

  function initHeaderMenu() {
    var ICONS = { search: 'search icon', account: 'profile icon' };
    onClick(function (e) {
      var a = closestA(e);
      if (!a) return;
      var li = a.closest('.section-header__list-item');
      // Cart icon is excluded from header_menu_click; skip it entirely so it doesn't
      // fall through to the generic menu-list branch below and still fire.
      if (li && li.getAttribute('data-name') === 'cart') return;
      var icon = li && ICONS[li.getAttribute('data-name')];
      if (icon) {
        push({
          event: 'header_menu_click',
          main_menu: icon,
          sub_menu: '-',
          click_text: '-',
          click_url: '-',
        });
        return;
      }
      // Studio nav has its own DOM (.nav_link_box > a, plain <li>); use the block's configured
      // label for main_menu instead of falling back to the clicked link's text.
      var studioNav = a.closest('.studio_navigation');
      if (studioNav) {
        var topUl = studioNav.querySelector('ul');
        var topLi = a.closest('li');
        while (topLi && topLi.parentNode !== topUl) {
          topLi =
            topLi.parentNode && topLi.parentNode.closest ? topLi.parentNode.closest('li') : null;
        }
        var parentLink = topLi && topLi.querySelector('.nav_link_box a');
        var studioText = txt(a);
        push({
          event: 'header_menu_click',
          main_menu: studioNav.getAttribute('data-ga-main-menu') || '-',
          sub_menu: studioText || '-',
          click_text: studioText,
          click_url: a.getAttribute('href'),
        });
        return;
      }
      if (!a.closest('.section-header__list, .mobile_menu, .desktop_menu')) return;
      var mainLink = li && li.querySelector('.section-header__list-item-link a');
      var clickText = txt(a);
      push({
        event: 'header_menu_click',
        main_menu: txt(mainLink) || clickText,
        sub_menu: a === mainLink ? '-' : clickText, // '-' on a top-level click
        click_text: clickText,
        click_url: a.getAttribute('href'),
      });
    });
  }

  function initFooterMenu() {
    onClick(function (e) {
      var a = closestA(e);
      if (!a || !a.closest('.section-footer__link-list, .section-footer__bottom-block-list'))
        return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return; // skip non-navigational (e.g. accessibility trigger)
      var box = a.closest('.section-footer__link-list-box');
      push({
        event: 'footer_menu_click',
        main_menu: txt(box && box.querySelector('.section-footer__link-list-title')) || '-',
        sub_menu: '-',
        click_text: txt(a),
        click_url: href,
      });
    });
  }

  // cta_click — opt-in via [data-ga-cta] attributes.
  function initCtaClicks() {
    onClick(function (e) {
      var el = e.target.closest && e.target.closest('[data-ga-cta]');
      if (!el) return;
      push({
        event: 'cta_click',
        section_name: el.getAttribute('data-ga-cta-section') || '',
        cta_position: el.getAttribute('data-ga-cta-position') || '',
        cta_text: el.getAttribute('data-ga-cta-text') || txt(el),
        click_url: el.getAttribute('href') || el.getAttribute('data-ga-cta-url') || '',
        page_url: window.location.pathname,
      });
    });
  }

  // newsletter_subscription — footer embed lives in .custom-klaviyo-form-wrapper; else it's the popup.
  function initNewsletter() {
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'submit') return;
      var el = document.querySelector('.klaviyo-form-' + e.detail.formId);
      var location =
        el && el.closest('.custom-klaviyo-form-wrapper') ? 'footer_newsletter' : 'popup_newsletter';
      push({ event: 'newsletter_subscription', method: 'email', form_location: location });
    });
  }

  // app_download_click
  function initMiscClicks() {
    onClick(function (e) {
      var a =
        e.target.closest &&
        e.target.closest(
          '[data-ga-app-download], a[href*="apps.apple.com"], a[href*="play.google.com"]',
        );
      if (a) {
        var href = a.getAttribute('href') || '';
        var platform =
          a.getAttribute('data-ga-app-platform') ||
          (/apple/i.test(href) ? 'ios' : /google/i.test(href) ? 'android' : '');
        if (!platform) {
          var alt = (a.querySelector('img') || {}).alt || '';
          platform = /app store/i.test(alt) ? 'ios' : /google play/i.test(alt) ? 'android' : '';
        }
        push({
          event: 'app_download_click',
          app_platform: platform || '',
          click_url: href,
          placement: a.getAttribute('data-ga-placement') || 'footer',
        });
      }
    });
  }

  // chat_widget - Gorgias floating chat. The launcher lives in Gorgias' own iframe, so we can't
  // catch clicks; hook the widget's own open/close events instead (fired once it finishes loading).
  function initChatWidget() {
    var initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve();
          });
        });

    initGorgiasChatPromise.then(function () {
      if (!window.GorgiasChat || typeof window.GorgiasChat.on !== 'function') return;
      window.GorgiasChat.on('widget:opened', function () {
        push({
          event: 'chat_widget',
          widget_action: 'open',
          widget_name: 'chatbot_widget',
        });
      });
      window.GorgiasChat.on('widget:closed', function () {
        push({
          event: 'chat_widget',
          widget_action: 'close',
          widget_name: 'chatbot_widget',
        });
      });
    });
  }

  // Exposed synchronously so Boost's afterRender hook can reach it before first render.
  window.BBGa4 = window.BBGa4 || {};
  window.BBGa4.onBoostRender = onBoostRender;

  ready(function () {
    firePageView();
    fireViewItem();
    initListing();
    initBoostSD();
    initCart();
    initHeaderMenu();
    initFooterMenu();
    initCtaClicks();
    initNewsletter();
    initMiscClicks();
    initChatWidget();
  });
})();
